import cloneDeep from 'lodash/cloneDeep';
import { isFunction, stringifyQueryParams } from '../../helpers';
import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

const SUCCESS = 'AUDIENCE_COURSES_SUCCESS';
const FAILURE = 'AUDIENCE_COURSES_FAILURE';
const LOADING = 'AUDIENCE_COURSES_LOADING';
const PRELOAD = 'AUDIENCE_COURSES_PRELOAD';

const initialState = {
  loaded: false,
  loading: false,
};

export default function audienceCoursesReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return Object.assign({}, cloneDeep(state), {
        loading: true,
      });

    case PRELOAD: {
      const previousState = cloneDeep(state);
      previousState.data.displayed = previousState.data.displayed.concat(
        action.data.json.data?.displayed || [],
      );
      return Object.assign(previousState, {
        loading: false,
      });
    }

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          loading: false,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(state, {
        error: true,
        loading: false,
        statusCode: action.data.statusCode,
      });

    default:
      return state;
  }
}

export function fetchAudienceCoursesSuccess(data) {
  return { type: SUCCESS, data };
}

export function loadAudienceCoursesSuccess(data) {
  return { type: PRELOAD, data };
}

export function fetchAudienceCoursesFailure(data) {
  return { type: FAILURE, data };
}

export function fetchAudienceCoursesLoading() {
  return { type: LOADING };
}

export function fetchAudienceCoursesAction(
  { page = 1, count = 20 } = {},
  callback,
) {
  return function (dispatch, getState, { Api, i18n, qs }) {
    dispatch(fetchAudienceCoursesLoading());

    const {
      pageConfig: { previewMode, siteId },
    } = getState();

    const basicView = page !== 1;
    const query = stringifyQueryParams({ page, count, basicView });

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchAudienceCourses({ siteId, query })
      .then((response) => {
        if (isFunction(callback)) {
          callback();
        }

        if (response.statusCode === 200) {
          if (basicView) {
            return dispatch(loadAudienceCoursesSuccess(response));
          }

          return dispatch(fetchAudienceCoursesSuccess(response));
        } else {
          return dispatch(fetchAudienceCoursesFailure(response));
        }
      });
  };
}
